/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<path pid="0" d="M10.88 5.636L7.32 2.67v1.78H3.165v2.374h4.153v1.78l3.56-2.967zM1.385 1.483h4.747V.296H1.386A1.19 1.19 0 0 0 .199 1.483V9.79a1.19 1.19 0 0 0 1.187 1.186h4.747V9.79H1.386V1.483z" _fill="#2B2A29" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/logout.js